<script>
module.exports = {};
</script>
<style lang="scss">
.layout {
    $this: &;

    &__container {
        position: relative;
        outline: none;

        .#{ $is-collapsed } & {
            overflow: hidden;
            max-height: 0;
        }

        &.edit-mode {
            border: solid 10px $layout-menu-color;

            .#{ $is-preview } & {
                border: none;
            }
        }
    }

    &__content {
        display: flex;
        flex-wrap: wrap;
    }

    &__menu {
        display: none;

        &.edit-mode {
            display: flex;
            padding: 0 30px 0 20px;

            .#{ $is-preview } & {
                display: none;
            }
        }
    }

    &__menu-primary {
        margin-right: auto;
    }

    &__menu-secondary {
        margin-left: auto;
    }

    &__button {
        background-color: $layout-menu-color;
        border: none;

        #{$this}__menu-primary & {
            margin-right: 4px;
        }

        #{$this}__menu-secondary & {
            margin-left: 4px;
        }
    }

    &__icon {
        color: $layout-icon-color;
        font-size: 14px;
        padding: 7px 12px;
        display: block;
    }
}
</style>
